module.exports = __webpack_public_path__ + "img/shield_vs_bug.7b8b0e54.svg";